// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ed3810f9","885":"6508018c"}[chunkId] + ".chunk.js";
};